var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinRedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99951 0.00402832C4.89632 0.00402832 2.37451 2.52528 2.37451 5.62763C2.37451 6.67737 2.6652 7.69902 3.21829 8.58005L7.6182 15.7787C7.69326 15.9005 7.80576 15.9756 7.93704 15.9943C8.11511 16.0224 8.31207 15.9474 8.41517 15.7694L12.8277 8.50504C13.3526 7.64278 13.6245 6.63991 13.6245 5.62763C13.6245 2.52528 11.1027 0.00402832 7.99951 0.00402832ZM7.99951 8.43943C6.42457 8.43943 5.18701 7.16475 5.18701 5.62763C5.18701 4.08111 6.45261 2.81583 7.99951 2.81583C9.54642 2.81583 10.812 4.08111 10.812 5.62763C10.812 7.15537 9.59323 8.43943 7.99951 8.43943Z",
    fill: "#FD003A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0.00402832V2.81583C9.54691 2.81583 10.8125 4.08111 10.8125 5.62763C10.8125 7.15537 9.59372 8.43943 8 8.43943V15.9998C8.15997 16.0035 8.32447 15.9268 8.41562 15.7694L12.8281 8.50504C13.3531 7.64278 13.625 6.63991 13.625 5.62763C13.625 2.52528 11.1032 0.00402832 8 0.00402832Z",
    fill: "#E50027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.996,
    fill: "white",
    transform: "translate(0 0.00402832)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinRedIcon);
export default __webpack_public_path__ + "static/media/PinRedIcon.d78d0e757e54e41319316e8a339b1614.svg";
export { ForwardRef as ReactComponent };